/* eslint-disable */
import styled from '@emotion/styled';

export const Label = styled.label`
  display: block;
  margin-bottom: 7px;
  color: ${({ theme, filled, light }) =>
    filled ? theme.palette.base : light ? '#fff' : theme.colors.input};
  font-size: ${({ filled }) => (filled ? '10px' : '14px')};
  position: absolute;
  left: ${({ withIcon, filled }) =>
    withIcon ? (filled ? '0px' : '24px') : '5px'};
  top: ${({ filled }) => (filled ? '-12px' : '10px')};
  opacity: ${({ filled }) => (filled ? 1 : 0.5)};
  transition: opacity 0.3s ease-in-out, top 0.3s ease-in-out,
    left 0.3s ease-in-out, color 0.3s ease-in-out, font-size 0.3s ease-in-out;
  text-transform: uppercase;
  font-weight: 600;
`;

export const Wrapper = styled.div`
  color: ${props => (props.withError ? props.theme.colors.error : '#585757')};
  width: 100%;
  margin-bottom: ${props => (props.single ? 0 : '30px')};
  position: relative;

  ${props =>
    props.withError
      ? `
    ${Label} {
      color: ${props.theme.colors.error}
    }
  `
      : null}
`;

export const Error = styled.div`
  color: ${props => props.theme.colors.error};
  font-size: 12px;
  line-height: 18px;
  position: absolute;
  bottom: -24px;
`;

export const Input = styled.input`
  border: none;
  border-bottom: 1px
    ${props => (props.withError ? props.theme.colors.error : '#DBDBDB')} solid;
  font-size: 14px;
  color: ${props =>
    props.withError
      ? props.theme.colors.error
      : props.light
      ? '#fff'
      : props.theme.colors.input};
  padding: 8px 5px;
  background-color: transparent;

  width: 100%;
  transition: border-color 0.3s ease-in-out;
  /* box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); */

  ${props => (props.withIcon ? `padding-left: 26px;` : null)}
  ${props =>
    props.as === 'textarea'
      ? `resize: vertical; height: 256px;`
      : null}

  ::-webkit-input-placeholder {
    color: ${props => props.theme.colors.text};
    opacity: 0.4;
  }

  :-ms-input-placeholder {
    color: blue;
    color: ${props => props.theme.colors.text};
    opacity: 0.4;
  }

  ::placeholder {
    color: blue;
    color: ${props => props.theme.colors.text};
    opacity: 0.4;
  }

  &:hover {
    border-color: #b7b7b7;
  }

  &:focus {
    outline: none;
    border-color: ${props =>
      props.withError ? props.theme.colors.error : props.theme.palette.base};
  }

  &:disabled {
    background-color: #f7f7f7;
    border-color: #f7f7f7;

    &:hover {
      border-color: #f7f7f7;
    }
  }
`;

export const CrossLine = styled.span`
  width: 100%;
  height: 2px;
  background: #005ad4;
  transform: rotate(26deg);
  position: absolute;
  left: 0;
  top: 6px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
`;

export const SwitchReadable = styled.button`
  display: block;
  border: none;
  background-color: transparent;
  cursor: pointer;
  z-index: 5;
  position: absolute;
  right: 14px;
  top: 46px;
  padding: 0;

  &:focus {
    outline: none;
  }

  img {
    transition: opacity 0.3s ease-in-out;
  }

  ${props =>
    props.readable
      ? `
      img {
        opacity: .4;
      }

      ${CrossLine} {
        opacity: 1;
      }
      `
      : null}
`;

export const Icon = styled.img`
  display: block;
  border: none;
  background-color: transparent;
  cursor: ${props => (props.onClick ? 'pointer' : null)};
  z-index: 5;
  position: absolute;
  left: 0px;
  top: 8px;
  padding: 0;
  width: 16px;
  height: 16px;
  object-fit: contain;
`;

export const ClearButton = styled.button`
  display: block;
  position: absolute;
  right: 5px;
  top: 8px;
  padding: 5px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.65, -0.29, 0.01, 2.12),
    opacity 0.15s ease-in-out;
  pointer-events: none;
  opacity: 0;
  transform: translateY(-50%);

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  &.visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: all;
  }
`;
